<div>
    <mat-progress-bar color="accent" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</div>
<div fxFlex="row" fxFlex>
    <div fxFlex="240px" class="sidenavigationTop hidexs">
        <div class="iwg-service-name">MyTalent</div>
        <div class="sidenavigationInner">

            <div>
                <button mat-button class="sidenavigationassbtn active-side-nav" [routerLink]="['my-talent-rate']"
                    layout>
                    Rate
                    <span class="activeiconcolor textSuccess"></span>
                </button>
            </div>
            <div>
                <button mat-button class="sidenavigationassbtn" layout (click)="loadMytalentsearch()">Search
                    <span flex></span>
                </button>
            </div>
            <app-buttonbar></app-buttonbar>
        </div>
    </div>
    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span>MyTalent</span> » <span class="iwg-page-header-small-title">Rate</span>
            </div>
            <mat-divider class="mb-2"></mat-divider>
            <div fxLayout="row" fxLayoutAlign="space-between" class="iwg-responsive">

                <div fxFlex.xs="100" class="one" class="vista-quotepage">
                    <div class="iwg-widget-box my-talent-rate width-300" >
                        <div class="iwg-widget-box-body">
                            <h3 style="font-size: 16px;">MyTalent</h3>
                            <form name="rateform" #rateform="ngForm">
                                <div class="md-input-container myrate">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Service</mat-label>
                                        <mat-select [(ngModel)]="myTalentRateForm.selectedServiceTypeId"
                                            (openedChange)="onOpen($event)" (selectionChange)="onStateChange($event)"
                                            name="selectedServiceTypeId"
                                            [panelClass]="isServiceLoading || !isOpen ? 'hide-dummy-option' : ''"
                                            required>
                                            <mat-option
                                                *ngIf="ServiceTypes && (ServiceTypes === null || !ServiceTypes.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <mat-option *ngFor="let ServiceType of ServiceTypes"
                                                [value]="ServiceType.ServiceTypeId">
                                                {{ServiceType.ServiceTypeName}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-icon
                                        matTooltip="Please select the service: Employer of Record for payrolled workers, Agent of Record for contractors."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container myrate">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>{{WorkerLabel}}</mat-label>
                                        <mat-select (selectionChange)="onworkerChange($event)"
                                            [(ngModel)]="myTalentRateForm.selectedCandidateId"
                                            name="selectedCandidateId"
                                            [panelClass]="isWorkerLoading || !isWorkerOpen ? 'hide-dummy-option' : ''"
                                            required>
                                            <mat-option
                                                *ngIf="ServiceTypes && (ServiceTypes === null || !ServiceTypes.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <mat-option *ngFor="let Candidate of Candidates"
                                                [value]="Candidate.CandidateId">
                                                {{Candidate.CandidateName}}</mat-option>
                                        </mat-select>

                                    </mat-form-field>
                                    <mat-icon
                                        [matTooltip]="myTalentRateForm.selectedServiceTypeId!=2?'Please select the worker.':'Please select the contractor.'"
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container myrate">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Select {{asssignmentLabel}}</mat-label>
                                        <mat-select (selectionChange)="onAssignmentChange($event)"
                                            [(ngModel)]="myTalentRateForm.selectedAssignmentId"
                                            name="selectedAssignmentId"
                                            [panelClass]="isAssignmentLoading || !isAssignmentOpen ? 'hide-dummy-option' : ''"
                                            required>
                                            <mat-option
                                                *ngIf="Assignments && (Assignments === null || !Assignments.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <mat-option *ngFor="let Assignment of Assignments"
                                                [value]="Assignment.AssignmentId">
                                                {{Assignment.AssignmentName}}</mat-option>
                                        </mat-select>

                                    </mat-form-field>

                                    <mat-icon
                                        [matTooltip]="myTalentRateForm.selectedServiceTypeId!=2?'Please select the worker’s ended assignment for which you would like to rate.':'Please select the contractor’s ended engagement for which you would like to rate.'"
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>

                                <div class="md-input-container myrate" *ngIf="!HideRattingsDiv">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Rating</mat-label>
                                        <mat-select [(ngModel)]="myTalentRateForm.selectedRattingId"
                                            name="selectedRattingId"
                                            [panelClass]="isAssignmentLoading || !isAssignmentOpen ? 'hide-dummy-option' : ''"
                                            required>
                                            <mat-option *ngIf="Rattings && (Rattings === null || !Rattings.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <mat-option *ngFor="let Ratting of Rattings" [value]="Ratting.RatingId">
                                                {{Ratting.RatingLevel + ' (' + Ratting.RatingName + ')'}}
                                            </mat-option>
                                        </mat-select>

                                    </mat-form-field>

                                    <mat-icon
                                        matTooltip="Please select the rating which you feel is applicable to the work performed."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container myrate" *ngIf="!HideExperienceLevelDiv">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Experience Level</mat-label>
                                        <mat-select [(ngModel)]="myTalentRateForm.selectedExperienceLevelId"
                                            name="selectedExperienceLevelId"
                                            [panelClass]="isAssignmentLoading || !isAssignmentOpen ? 'hide-dummy-option' : ''"
                                            required>
                                            <mat-option
                                                *ngIf="ExperienceLevels && (ExperienceLevels === null || !ExperienceLevels.length)"
                                                class="minh88" disabled>
                                                <div class="select-placeholder-container">
                                                    <mat-spinner class="spinner" diameter="20"></mat-spinner>
                                                </div>
                                            </mat-option>
                                            <mat-option *ngFor="let ExperienceLevel of ExperienceLevels"
                                                [value]="ExperienceLevel.DesignationId">
                                                {{ExperienceLevel.DesignationName}}
                                            </mat-option>
                                        </mat-select>

                                    </mat-form-field>

                                    <mat-icon
                                        matTooltip="Please select the experience level which you feel is applicable to the work performed."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container mytalent-rate-tarea" *ngIf="!HideExpertiseDescriptionDiv"
                                    fxLayout="row" fxLayoutAlign="space-between start">
                                    <mat-form-field class="mat-form-withtooltip">
                                        <mat-label>Expertise</mat-label>
                                        <textarea matInput name="experties"
                                            [(ngModel)]="myTalentRateForm.expertiseDescription"
                                            style="resize:none;min-height:135px;max-height:135px;padding-top: 4px;overflow-y: auto;border: 1px solid rgba(0,0,0,.12)!important;border-bottom: none !important;"
                                            maxlength="200"></textarea>
                                    </mat-form-field>
                                    <mat-icon style="margin-top: 20px;position: inherit;"
                                        matTooltip="Please provide detailed descriptions of expertise, skill sets, qualifications, and strengths that was exhibited in the work performed.  Your input will be utilized by the search functionality in MyTalent."
                                        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">
                                        help
                                    </mat-icon>
                                </div>
                                <div class="md-input-container mb10" *ngIf="!HideSubmitButtonDiv"
                                    style="text-align: center;">
                                    <button mat-button class="md-primary md-raised iwg-md-raised" (click)="submit()"
                                        type="submit"
                                        style="background-color:#224d95; color: rgba(255,255,255,0.87);box-shadow: 0 2px 5px 0 rgb(0 0 0 / 26%);min-width: 88px;">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="iwg-space"></div>
                <div class="flex" layout-xs="column"  fxFlex.xs="100" fxFlex="flex" *ngIf="!HideAssignmentDetailsDiv">
                    <div class="iwg-widget-box" style="margin-bottom: 0px;">
                        <div class="iwg-widget-box-header">{{WorkerLabel}} Information</div>
                        <div class="iwg-widget-box-body" layout="row">
                            <div flex>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">{{WorkerLabel}} </label>
                                    <p class="iwg-regular-value">{{assignment?.Worker.Name | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="(assignment?.Worker?.CompanyName!= '' && assignment?.Worker?.CompanyName != null && assignment?.Worker?.CompanyName!=assignment?.Worker?.Name) && assignment?.Service?.ServiceTypeEnumID==2">
                                    <label class="iwg-regular-label">Business Name</label>
                                    <p class="iwg-regular-value">{{assignment?.Worker.CompanyName | blank}}</p>
                                </div>

                               
                                <div class="iwg-widget-box-card">
                                    <p class="iwg-regular-value">
                                        <mat-icon style="color: #757575;">email</mat-icon>
                                        <a class="mailicon-p"
                                            href="mailto:{{assignment?.Worker.ContactInfo.Email | blank}}">{{assignment?.Worker.ContactInfo.Email | blank}}</a>
                                    </p>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="iwg-space"></div>
                    <div *ngIf="!HideAssignmentDetailsDiv" class="iwg-widget-box" flex>
                        <div class="iwg-widget-box-header">{{asssignmentLabel}} Information</div>
                        <div class="iwg-widget-box-body" layout="row">
                            <div flex>
                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">ID</label>
                                    <p class="iwg-regular-value">{{assignment.DisplayID}}</p>
                                </div>

                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label"> {{asssignmentLabel}} Status</label>
                                    <p class="iwg-regular-value">{{assignment?.Status.Name| blank}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 3">
                                    <label class="iwg-regular-label">Questionnaire Status</label>
                                    <p class="iwg-regular-value">{{assignment?.QuestionnaireStatus| blank}}</p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                                    <label class="iwg-regular-label">End Client</label>
                                    <p class="iwg-regular-value">{{assignment?.EndClientName| blank}}</p>
                                </div>

                                <div class="iwg-widget-box-card" layout="column" *ngIf="assignment?.SOWFile.Name">
                                    <label class="iwg-regular-label">Statement of Work</label>
                                    <p class="iwg-regular-value"
                                        style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{assignment?.SOWFile.Name | blank}}
                                        <button mat-button class="mat-icon-button" [disabled]="isLoading"
                                            *ngIf="assignment?.SOWFile.Name" (click)="downloadSOWFile()">
                                            <mat-icon style="color: #737373;">file_download</mat-icon>
                                        </button>
                                    </p>
                                </div>

                                <div class="iwg-widget-box-card" *ngIf="assignment?.Team != null">
                                    <label class="iwg-regular-label">Team</label>
                                    <p class="iwg-regular-value">{{assignment?.Team.Name | blank}}</p>
                                </div>

                                <div class="iwg-widget-box-card">
                                    <label class="iwg-regular-label">Manager</label>
                                    <p class="iwg-regular-value">{{assignment?.Manager.Name | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card">
                                    <p class="iwg-regular-value">
                                        <mat-icon style="color: #757575;">email</mat-icon>
                                        <a class="mailicon-p"
                                            href="mailto:{{assignment?.Manager?.ContactInfo?.Email | blank}}">{{assignment?.Manager?.ContactInfo?.Email | blank}}</a>
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && !US_EOR">
                                    <label class="iwg-regular-label">Business Entity in Country</label>
                                    <p class="iwg-regular-value">{{assignment?.EntityInCountry | yesNoBlank}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                    <label class="iwg-regular-label">Country of Citizenship</label>
                                    <p class="iwg-regular-value">{{assignment.ExpatCountryName | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                    <label class="iwg-regular-label">Worker Residence</label>
                                    <p class="iwg-regular-value">
                                        {{assignment?.IsExpat == true ? 'Expatriate' : 'Local'}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.IsExpat == true">
                                    <label class="iwg-regular-label">Visa / Work Permit Required</label>
                                    <p class="iwg-regular-value">
                                        {{assignment?.IsExpatVisaNeeded == true ? 'Yes' : 'No'}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.IsExpat == true">
                                    <label class="iwg-regular-label">Worker is in Country</label>
                                    <p class="iwg-regular-value">{{assignment.IsExpatInCountry == true ? 'Yes' : 'No'}}
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && !US_EOR">
                                    <label class="iwg-regular-label">Offer Letter Sent to Worker</label>
                                    <p class="iwg-regular-value">{{assignment?.IsOfferLetterAttached | yesNoBlank}}</p>
                                </div>
                                <div class="iwg-widget-box-card" layout="column"
                                    *ngIf="assignment?.OfferLetterFile?.Name">
                                    <label class="iwg-regular-label">Offer Letter</label>
                                    <p class="iwg-regular-value"
                                        style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                        {{assignment?.OfferLetterFile?.Name | blank}}
                                        <mat-button mat-button class="mat-icon-button" [disabled]="isLoading"
                                            *ngIf="assignment?.OfferLetterFile.Name"
                                            (click)="downloadOfferLetterFile()">
                                            <mat-icon style="color: #737373;">file_download</mat-icon>
                                        </mat-button>
                                    </p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="assignment.Service.ServiceTypeEnumID == 1">
                                    <label class="iwg-regular-label">Notice Time</label>
                                    <p class="iwg-regular-value">{{assignment?.TimeForNotice | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                    <label class="iwg-regular-label">Worksite Address</label>
                                    <p class="iwg-regular-value">Street 1:
                                        {{assignment?.WorksiteAddress?.StreetAddress1}}</p>
                                    <p class="iwg-regular-value">Street 2:
                                        {{assignment?.WorksiteAddress?.StreetAddress2}}</p>
                                    <p class="iwg-regular-value">City: {{assignment?.WorksiteAddress?.City}}</p>
                                    <p class="iwg-regular-value">State/Region:
                                        {{assignment?.WorksiteAddress?.Region?.Name}}</p>
                                    <p class="iwg-regular-value">Postal Code:
                                        {{assignment?.WorksiteAddress?.PostalCode}}</p>
                                    <p class="iwg-regular-value">Country:
                                        {{assignment?.WorksiteAddress?.Country?.Name | blank}}</p>
                                </div>
                                <div class="iwg-widget-box-card"
                                    *ngIf="assignment?.Service.ServiceTypeEnumID == 3 || assignment?.Service.ServiceTypeEnumID == 2">
                                    <label class="iwg-regular-label"
                                        *ngIf="assignment?.Service.ServiceTypeEnumID == 3">Worksite Location</label>
                                    <label class="iwg-regular-label"
                                        *ngIf="assignment?.Service.ServiceTypeEnumID == 2">Location</label>
                                    <p class="iwg-regular-value">State/Region: {{assignment?.Region?.Name  | blank}}</p>
                                    <p class="iwg-regular-value">Country: {{assignment?.Country?.Name | blank}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="iwg-space"></div>
                <div class="iwg-widget-box flex" layout-xs="column"  fxFlex.xs="100" fxFlex="flex" *ngIf="!HideAssignmentDetailsDiv">
                    <div class="iwg-widget-box-header">{{jobLabel}} Information</div>
                    <div class="iwg-widget-box-body" layout="row">
                        <div flex>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">{{jobTitleLabel}}</label>
                                <p class="iwg-regular-value"
                                    style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                    {{assignment?.JobTitle | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">{{jobDescriptionLabel}}</label>
                                <pre class="pre-text-format">{{assignment?.JobDescription | blank}}</pre>
                            </div>

                            <div class="iwg-widget-box-card" layout="column"
                                *ngIf="assignment?.JobDescriptionFile?.Name">
                                <label class="iwg-regular-label">{{jobDescriptionLabel}} File</label>
                                <p class="iwg-regular-value"
                                    style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                    {{assignment?.JobDescriptionFile?.Name | blank}}
                                    <button mat-button class="mat-icon-button" [disabled]="isLoading"
                                        *ngIf="assignment?.JobDescriptionFile?.Name"
                                        (click)="downloadJobDescriptionFile()">
                                        <mat-icon style="color: #737373;">file_download</mat-icon>
                                    </button>
                                </p>
                            </div>

                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 3">
                                <label class="iwg-regular-label">Submitted</label>
                                <p class="iwg-regular-value">{{assignment?.CreationDate | date}}</p>
                            </div>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">Start Date</label>
                                <p class="iwg-regular-value">{{assignment?.StartDate | date}}</p>
                            </div>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">Estimated End Date</label>
                                <p class="iwg-regular-value">{{assignment?.ExpectedEndDate | date | blank}}</p>
                            </div>

                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">Termination Notice Period</label>
                                <p class="iwg-regular-value">{{assignment?.TerminationNoticePeriod | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">Department</label>
                                <p class="iwg-regular-value">{{assignment?.Department | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card">
                                <label class="iwg-regular-label">Cost Center</label>
                                <p class="iwg-regular-value">{{assignment?.CostCenter | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card"
                                *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.ExternalIdentifierLabel != ''">
                                <label class="iwg-regular-label">{{assignment?.ExternalIdentifierLabel}}</label>
                                <p class="iwg-regular-value">{{assignment?.ExternalIdentifier | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Pay Rate</label>
                                <p class="iwg-regular-value">
                                    {{assignment?.PayRate | currency:(assignment?.PayCurrency?.Symbol|| ''):'symbol-narrow':'1.2-2'}}
                                    ({{assignment?.PayCurrency?.Abbreviation}})
                                    {{assignment?.PayRateTimeframe?.Name==null ? '' : '/'+assignment?.PayRateTimeframe?.Name}}
                                </p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 2">
                                <label class="iwg-regular-label">Charge Types</label>
                                <ul>
                                    <li class="iwg-regular-value" *ngFor="let item of assignment?.ChargeTypes">{{item}}
                                    </li>
                                </ul>
                            </div>
                            <div class="iwg-widget-box-card"
                                *ngIf="assignment?.Service?.ServiceTypeEnumID == 3 || assignment?.Service?.ServiceTypeEnumID == 2">
                                <label class="iwg-regular-label">Total Project Amount</label>
                                <p class="iwg-regular-value">
                                    {{assignment?.PayRate | currency:(assignment?.PayCurrency?.Symbol|| ''):'symbol-narrow':'1.2-2'}}
                                    ({{assignment?.PayCurrency?.Abbreviation}})
                                </p>
                            </div>
                            <div class="iwg-widget-box-card"
                                *ngIf="assignment?.Service?.ServiceTypeEnumID == 3 || assignment?.Service?.ServiceTypeEnumID == 2">
                                <label class="iwg-regular-label" *ngIf="assignment?.Service?.ServiceTypeEnumID == 2">Pay
                                    Structure</label>
                                <label class="iwg-regular-label"
                                    *ngIf="assignment?.Service?.ServiceTypeEnumID == 3">Payment Structure</label>
                                <p class="iwg-regular-value">{{assignment?.PayRateTimeframeStructure?.Name | blank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 2">
                                <label class="iwg-regular-label">Pay Amount</label>
                                <p class="iwg-regular-value">
                                    {{assignment?.PartnerInvoiceTotal | currency:(assignment?.PayCurrency?.Symbol|| ''):'symbol-narrow':'1.2-2'}}
                                    ({{assignment?.PayCurrency?.Abbreviation}})
                                </p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Weekly Hours</label>
                                <p class="iwg-regular-value">{{assignment?.HoursPerWeek | number : '1.2-2'}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                <label class="iwg-regular-label">Full-time or Part-time</label>
                                <p class="iwg-regular-value">{{ (assignment?.IsPartime) ? 'Part-time' : 'Full-time'}}
                                </p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                <label class="iwg-regular-label">Regular or Sporadic</label>
                                <p class="iwg-regular-value">{{ (assignment?.IsSproradic) ? 'Sproadic' : 'Regular'}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                <label class="iwg-regular-label">Exempt or Non-Exempt</label>
                                <p class="iwg-regular-value">{{ (assignment?.IsExempt) ? 'Exempt' : 'Non-Exempt'}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Overtime Authorized</label>
                                <p class="iwg-regular-value">{{assignment?.IsOvertimeAuthorized | yesNoBlank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Expense Reimbursement Authorized</label>
                                <p class="iwg-regular-value">{{assignment?.IsExpensesAuthorized | yesNoBlank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Commissions Authorized</label>
                                <p class="iwg-regular-value">{{assignment?.IsCommissionAuthorized | yesNoBlank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Bonuses Authorized</label>
                                <p class="iwg-regular-value">{{assignment?.IsBonusAuthorized | yesNoBlank}}</p>
                            </div>
                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Compensation Details</label>
                                <p class="iwg-regular-value">{{assignment?.OtherCompensation | blank}}</p>
                            </div>

                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Travel Required</label>
                                <p class="iwg-regular-value">{{assignment?.IsTravelRequired | yesNo}}</p>
                            </div>
                            <div class="iwg-widget-box-card"
                                *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.IsTravelRequired == true">
                                <label class="iwg-regular-label">Travel Locations</label>
                                <p class="iwg-regular-value">{{assignment?.TravelLocations}}</p>
                            </div>

                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Driving Required</label>
                                <p class="iwg-regular-value">{{assignment.IsDrivingRequired | yesNo}}</p>
                            </div>

                            <div class="iwg-widget-box-card" *ngIf="assignment?.Service?.ServiceTypeEnumID == 1">
                                <label class="iwg-regular-label">Equipment Provided</label>
                                <p class="iwg-regular-value">{{assignment?.IsEquipmentProvided | yesNo}}</p>
                            </div>

                            <div class="iwg-widget-box-card"
                                *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.EquipmentProvided != '' && assignment?.EquipmentProvided != null">
                                <label class="iwg-regular-label">Equipment List</label>
                                <p class="iwg-regular-value">{{assignment?.EquipmentProvided  | blank}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>


    </div>


</div>
